import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-bulk-delete-petitions',
		path: '/admin/bulk_delete_petitions',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-petition-bulkDelete" */ './index'), {
			exportName: 'AdminBulkDeletePetitions',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['supportSenior', 'policy'],
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
